export const IRAN_MOBILE_REGEX = /^(\+98|0)?9\d{9}$/;
export const ALPHABET_REGEX = /^[\p{L}\s]+$/u;
export const PRICE_REGEX = /^\d+$/;
export const ACCOUNT_NUMBER_REGEX = /^\d{12,13}$/;
export const IBAN_REGEX = /^IR\d{24}$/;
export const CARD_NUMBER_REGEX = /^(\d{16})$/;
export const NATIONAL_ID_REGEX = /^[0-9]{10}$/;
export const NUMBER_REGEX = /^\d+$/;
export const DATE_REGEX = /^\d{4}-\d{2}-\d{2}$/;
export const ER_RATE_INPUT = /^(100|(\d{1,2}(\.\d+)?))$/;
